import { FC } from 'react'
import { MembersContent } from 'components/pages/Workspace/MembersContent'
import { MembersContentContextProvider } from 'components/pages/Workspace/MembersContent/MembersContent.context'

export const WorkspaceMembersContent: FC = () => {
  return (
    <MembersContentContextProvider>
      <MembersContent />
    </MembersContentContextProvider>
  )
}
